import React from "react";
import { Box, Typography } from "@mui/material";
import LoadingComponent from "@Components/LoadingComponent/LoadingComponent";
import ChatBubbleStyles from "./ChatBubbleStyles";

const ChatBubble = ({
  text,
  isBot,
  loading,
  error,
  repliedMessageText = null,
}) => {
  if (error) {
    return (
      <ChatBubbleStyles className="bubble" isBot={isBot} error>
        <Typography className="loadingText">
          Something went wrong. Please try again.
        </Typography>
      </ChatBubbleStyles>
    );
  }

  return (
    <ChatBubbleStyles className="bubble" isBot={isBot}>
      {repliedMessageText && (
        <Box className="repliedText">{repliedMessageText}</Box>
      )}
      {loading ? (
        <Box className="loadingMessage">
          <Typography className="loadingText">sending...</Typography>
          <Box className="LoadingComponent">
            <LoadingComponent size="18px" color="white" />
          </Box>
        </Box>
      ) : (
        <Typography className="bubbleText">{text}</Typography>
      )}
    </ChatBubbleStyles>
  );
};

export default React.memo(ChatBubble);
